import React from "react";
import { useInView } from "react-intersection-observer";
import { RevealWrapper } from "./styles";

type RevealDirection = "up" | "left" | "right";

interface RevealProps {
	children: React.ReactNode;
	direction?: RevealDirection;
	delay?: number;
	className?: string;
}

const Reveal = ({ children, direction = "up", delay = 0, className }: RevealProps) => {
	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold: 0.15
	});

	return (
		<RevealWrapper
			ref={ref}
			className={`${className || ""} ${inView ? "in-view" : ""}`}
			$direction={direction}
			style={{ transitionDelay: `${delay}ms` }}
		>
			{children}
		</RevealWrapper>
	);
};

export default Reveal;
